import React from "react";
import { Editor, Element, Frame } from "@craftjs/core";
import { Youtube, Video } from "@uiComponents/media";
import { Global } from "@emotion/react";

import {
  Page,
  Text,
  Container,
  Image,
  BuilderBlock,
  NoBlock,
  Columns,
  Column,
  Box,
} from "@uiComponents";
import {
  BuilderContextProvider,
  RenderNode,
  Viewport,
  PreviewPanel,
} from "./editor";
import { globalStyles } from "./styles";
import { ICustomComponent } from "./types";

export interface IModirBuilderProps {
  jsonContent?: string;
  onSave?: (jsonContent: string) => void;
  onPreview?: (jsonContent: string) => void;
  customResolver?: Record<string, string | React.ElementType>;
  customComponents?: ICustomComponent[];
}

export * from "./types";

export const ModirBuilder: React.FC<
  React.PropsWithChildren<IModirBuilderProps>
> = ({
  jsonContent,
  onSave,
  onPreview,
  customResolver,
  customComponents,
  children,
}) => {
  return (
    <>
      <Global styles={globalStyles} />

      <Editor
        resolver={{
          Page,
          BuilderBlock,
          Text,
          Container,
          Video,
          Youtube,
          Image,
          Columns,
          Column,
          NoBlock,
          Box,
          ...customResolver,
        }}
        enabled={true}
        onRender={RenderNode}
      >
        <BuilderContextProvider
          onSave={onSave}
          onPreview={onPreview}
          pageContent={jsonContent}
          customComponents={customComponents}
        >
          <Viewport>
            {/* <IFrame width={`100%`} height={`100%`}> */}

            {/* <Element
              is="div"
              canvas
              className="container vh-100 bg-white"
              css={{ height: "100vh!important", backgroundColor: "#fff" }}
            > */}
            {/* <div className="container vh-100 bg-white"> */}
            <Frame>
              <Element is={Page} canvas custom={{ displayName: "Page" }}>
                {/* <Text
                    fontSize="14"
                    fontWeight="400"
                    text="Welcome to marketplace"
                    textAlign="center"
                    // margin={["0", "0", "0", "0"]}
                    // padding={["0", "0", "0", "0"]}
                  ></Text> */}
                {children}
              </Element>
            </Frame>
            {/* </div> */}
            {/* </Element> */}

            {/* </IFrame> */}
          </Viewport>
        </BuilderContextProvider>
      </Editor>
    </>
  );
};

export const ModirPreview: React.FC<
  React.PropsWithChildren<IModirBuilderProps>
> = ({
  jsonContent,
  onPreview,
  customResolver,
  customComponents,
  children,
}) => {
  return (
    <>
      <Global styles={globalStyles} />

      <Editor
        resolver={{
          Page,
          BuilderBlock,
          Text,
          Container,
          Video,
          Youtube,
          Image,
          Columns,
          Column,
          NoBlock,
          Box,
          ...customResolver,
        }}
        enabled={false}
        onRender={RenderNode}
      >
        <BuilderContextProvider
          onPreview={onPreview}
          pageContent={jsonContent}
          customComponents={customComponents}
        >
          <PreviewPanel>
            <Frame>
              <Element is={Page} canvas custom={{ displayName: "Page" }}>
                {children}
              </Element>
            </Frame>
          </PreviewPanel>
        </BuilderContextProvider>
      </Editor>
    </>
  );
};
